export default {
  "signEmp": {
    icon: 'sign-pencil-outline',
    id: 'signEmp',
    name: 'Firma empleador'
  },
  "signDef": {
    icon: 'sign-pencil-outline',
    id: 'signDef',
    name: 'Firma colaborador'
  },
  "rotatePdf": {
    icon: 'circle-arrow-outline',
    id: 'rotatePdf',
    name: 'Rotación'
  },
  'cutPdf': {
    icon: 'crop-outline',
    id: 'cutPdf',
    name: 'Corte'
  }
}